import axios from 'axios';
import { serverConfig } from './server-config';

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Auth token has expired or is invalid, delete it from local storage
            localStorage.removeItem('authToken');
            location.reload();
        }
        return Promise.reject(error);
    }
);

export const ClientFolderService = {

    createFolder: (clientId, folderName) => {
        return axios.post(
            `https://${serverConfig.serverBaseAddress}/signite/client-folder/create?clientId=${clientId}&folderName=${folderName}`,
            null,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                },
            }
        );
    },

    listCuratedFolders: (
        clientId,
        type = "CURATED",
        page = 0,
        size = 10
    ) => {
        return axios.get(
            `https://${serverConfig.serverBaseAddress}/signite/client-folder/folders/list/${clientId}`,
            {
                params: {
                    type,
                    page,
                    size
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            }
        );
    },

    listShortlistedFolders: (
        clientId,
        type = "SHORTLISTED",
        page = 0,
        size = 10
    ) => {
        return axios.get(
            `https://${serverConfig.serverBaseAddress}/signite/client-folder/folders/list/${clientId}`,
            {
                params: {
                    type,
                    page,
                    size
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            }
        );
    },

    getCuratedCandidates: async (clientId, folderId, page = 0, size = 10, name = '') => {
        const response = await axios.get(`https://${serverConfig.serverBaseAddress}/signite/client-folder/curated/list/${clientId}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('authToken'),
            },
            params: {
                folderId: folderId || undefined,
                page: page,
                size: size,
                name: name,
            }
        });
        return {
            curatedList: response.data.curatedList || [],
            hasNext: response.data.hasNext || false,
            page: response.data.page || 0,
            totalCount: response.data.totalCount || 0,
            totalPages: response.data.pageCount || Math.ceil(response.data.totalCount / size),
        };
    },

    renameFolder: (clientId, folderId, newFolderName) => {
        return axios.post(
            `https://${serverConfig.serverBaseAddress}/signite/client-folder/rename?clientId=${clientId}&folderId=${folderId}&newFolderName=${newFolderName}`,
            null,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                },
            }
        );
    },

    deleteFolder: (folderId, clientId) => {
        return axios.post(
            `https://${serverConfig.serverBaseAddress}/signite/client-folder/delete/${folderId}`,
            null,
            {
                params: { clientId },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            }
        );
    },
};
